import React from 'react';
import { Modal, Form, Input, Button, Alert } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';

const { TextArea } = Input;

const RejectReasonModal = ({ visible, onClose, onReject, application, loading }) => {
  const [form] = Form.useForm();

  const handleSubmit = () => {
    form.validateFields()
      .then(values => {
        onReject(values.reason);
      })
      .catch(info => {
        console.log('Validation Failed:', info);
      });
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title={
        <span>
          <CloseCircleOutlined style={{ marginRight: 8, color: '#ff4d4f' }} />
          Reject Application
        </span>
      }
      open={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel} disabled={loading}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleSubmit}
          loading={loading}
          danger
        >
          Reject Application
        </Button>,
      ]}
      width={500}
    >
      <div>
        <div style={{ marginBottom: 16 }}>
          <p><strong>Applicant:</strong> {application?.applicant_name || 'N/A'}</p>
          <p><strong>Facility:</strong> {application?.facility || 'N/A'}</p>
          <p><strong>Event Date:</strong> {application?.event_date || 'N/A'}</p>
          <p><strong>Email:</strong> {application?.contact_email || 'N/A'}</p>
        </div>

        <Form
          form={form}
          layout="vertical"
        >
          <Form.Item
            label="Reason for Rejection"
            name="reason"
            rules={[
              { required: true, message: 'Please provide a reason for rejection' },
            ]}
          >
            <TextArea
              rows={4}
              placeholder="Enter the reason for rejecting this application..."
            />
          </Form.Item>
        </Form>

        <Alert
          message="Important"
          description="The applicant will be notified that their application has been rejected."
          type="warning"
          showIcon
        />
      </div>
    </Modal>
  );
};

export default RejectReasonModal;
